/* The Veterans Day Challenge window lives in the config service as two ISO
/* instants with their zone - see utils/isVeteransDayChallengeVisible. */
export const VETERANS_DAY_CHALLENGE_START_KEY = 'VETERANS_DAY_CHALLENGE_START';
export const VETERANS_DAY_CHALLENGE_END_KEY = 'VETERANS_DAY_CHALLENGE_END';
